import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CouponCard from "../components/CouponCard";
import CouponPlaceholderCard from "../components/CouponPlaceholderCard";
import { api } from "../lib/api";
import { Sparkles } from "lucide-react";

export default function Coupons() {
  const { t } = useTranslation();
  const [coupons, setCoupons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("todos");

  useEffect(() => {
    setLoading(true);
    const params = filter === "patrocinados" ? { sponsored: true } : {};
    api.listCoupons(params).then((data) => {
      setCoupons(data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [filter]);

  // Mostrar siempre 4 placeholders en grid 2x2 cuando no hay Huesos reales.
  const placeholdersNeeded = coupons.length === 0 ? 4 : Math.max(0, 4 - coupons.length);

  return (
    <div className="max-w-7xl mx-auto px-4 lg:px-8 py-8" data-testid="huesos-page">
      <header className="mb-8">
        <div className="font-mono text-[10px] uppercase tracking-widest text-[#FEBA01]">
          {t("huesos.eyebrow")}
        </div>
        <h1 className="mt-1 font-display text-5xl sm:text-6xl uppercase tracking-tighter leading-none">
          {t("huesos.title")}
        </h1>
        <p className="mt-3 text-[#A3A3A3] max-w-2xl">{t("huesos.desc")}</p>
      </header>

      {coupons.length > 0 && (
        <div className="flex gap-2 mb-6">
          {["todos", "patrocinados"].map((f) => (
            <button
              key={f}
              onClick={() => setFilter(f)}
              data-testid={`hueso-filter-${f}`}
              className={`px-4 py-2 font-mono uppercase text-xs tracking-widest border-2 ${
                filter === f
                  ? "bg-[#FEBA01] text-black border-[#FEBA01]"
                  : "border-[#333] text-[#F5F5F5] hover:border-[#FEBA01] hover:text-[#FEBA01]"
              }`}
            >
              {f === "todos" ? t("huesos.filterAll") : (
                <span className="inline-flex items-center gap-1"><Sparkles size={11} /> {t("huesos.filterSponsored")}</span>
              )}
            </button>
          ))}
        </div>
      )}

      {loading ? (
        <div className="beer-pour" />
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-testid="huesos-grid">
          {coupons.map((c) => <CouponCard key={c.id} coupon={c} />)}
          {Array.from({ length: placeholdersNeeded }).map((_, i) => (
            <CouponPlaceholderCard key={`ph-${i}`} index={i} />
          ))}
        </div>
      )}
    </div>
  );
}
